import { openBlock as t, createElementBlock as a, createStaticVNode as e } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, l = /* @__PURE__ */ e('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#D80027" d="M19.13 20H40a19.99 19.99 0 0 0-.69-5.217H19.13V20Zm0-10.435h17.934a20.103 20.103 0 0 0-4.615-5.217H19.13v5.217ZM20 40c4.707 0 9.033-1.627 12.45-4.348H7.55A19.915 19.915 0 0 0 20 40ZM2.935 30.435h34.13a19.88 19.88 0 0 0 2.246-5.218H.689a19.878 19.878 0 0 0 2.246 5.218Z"></path><path fill="#0052B4" d="M20 20V0C8.954 0 0 8.954 0 20h20Z"></path><path fill="#FFDA44" d="M13.3 17.12a4.946 4.946 0 1 1 2.352-9.297 6.087 6.087 0 1 0 0 8.702c-.7.38-1.5.595-2.353.595Z"></path><path fill="#FFDA44" d="m14.693 8.696.878 1.836 1.983-.458-.888 1.83 1.595 1.265-1.986.448.006 2.035-1.588-1.273-1.588 1.273.006-2.035-1.986-.448 1.595-1.264-.888-1.831 1.983.458.878-1.836Z"></path>', 5), o = [
  l
];
function c(i, n) {
  return t(), a("svg", h, [...o]);
}
const s = { render: c };
export {
  s as default,
  c as render
};
